import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { lt, showSuccessAlert } from '@mews/framework';

export const useDeleteProductCategoryDialog = ({ productCategoryId }: { productCategoryId: string }) => {
    const currentEnterpriseId = useCurrentEnterpriseId();
    const { mutateAsync } = useRepositoryMutation('productCategories', 'delete', {
        invalidateQueries: { products: ['getOverviewEntries', 'getAll'] },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('ProductCategoryDeleteSuccessMessage'),
            });
        },
    });

    return useDeleteConfirmationDialog({
        deleteAction: async () =>
            mutateAsync({ productCategoryIds: [productCategoryId], enterpriseIds: [currentEnterpriseId] }),
        renderContent: () => lt('DeleteProductDialogDescription'),
        title: lt('ProductCategoryDeleteDialogTitle'),
    });
};
